import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import HelpIconButton from "../../Components/Buttons/Iconbuttons/HelpIconButton";

export default function BooleanQuestion({
  fieldValue,
  fieldLabel,
  modalTitle,
  modalDescription,
  handleChange,
  modalOff = false,
}) {
  return (
    <div className="mb-4 flex w-full items-start gap-2 text-[#666666]">
      <div>
        <p className="text-[15px] font-semibold text-slate-700">{fieldLabel}</p>
        <RadioGroup
          row
          aria-label={fieldLabel}
          value={String(fieldValue ?? false)}
          name="radio-buttons-group"
          onChange={handleChange}
        >
          <FormControlLabel
            value={true}
            control={
              <Radio
                sx={{
                  "&.Mui-checked": {
                    color: "rgb(241,93,34)",
                  },
                }}
              />
            }
            label="Yes"
          />
          <FormControlLabel
            value={false}
            control={
              <Radio
                sx={{
                  "&.Mui-checked": {
                    color: "rgb(241,93,34)",
                  },
                }}
              />
            }
            label="No"
          />
        </RadioGroup>
      </div>
      {!modalOff && (
        <HelpIconButton title={modalTitle} description={modalDescription} />
      )}
    </div>
  );
}
